import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ConfigProvider } from 'antd';
import ES from 'antd/lib/locale/es_ES';
import FR from 'antd/lib/locale/fr_FR';

import { useIntl, AppIntlContext } from 'common/config/i18n';
import { ServiceTypesActions, StationsActions, TranslationLanguagesActions } from 'common/config/store';
import { isEspagne } from 'common/config/env';

import AppRouter from './app-router';

const AppComponent: React.FC = () => {
  const i18n = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    // Non-Standard Feature - https://developer.mozilla.org/en-US/docs/Web/CSS/zoom
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.body.style.zoom = '80%';
  }, []);

  useEffect(() => {
    dispatch(StationsActions.fetchStations());
    dispatch(ServiceTypesActions.fetchServiceTypes());
    dispatch(TranslationLanguagesActions.fetchTranslationLanguages());
  }, [dispatch]);

  const localeForAntd = isEspagne ? ES : FR;

  return (
    <AppIntlContext.Provider value={i18n}>
      <ConfigProvider locale={localeForAntd}>
        <AppRouter />
      </ConfigProvider>
    </AppIntlContext.Provider>
  );
};

export default AppComponent;
